import * as React from "react";
import { forwardRef } from "react";
const SvgArrow = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 6, viewBox: "0 0 12 6", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M0.984375 0.984375H11.0156L6 6L0.984375 0.984375Z", fill: "#475467" }));
const ForwardRef = forwardRef(SvgArrow);
export { ForwardRef as ReactComponent };
